<template>
  <div class="historyRecord common_group">
    <div class="title">
      <img src="@/assets/images/historyIcon.png">
      <span>历史记录</span>
    </div>
    <commonTable ref="historyRecordTable" />
  </div>
</template>

<script>
  import commonTable from 'components/commonTable';
  import { TableColumns, TableRow } from '@/utils/tableOptions';
  export default {
    data () {
      return {
        tableList: []
      };
    },
    components: {
      commonTable
    },
    props: {
      detailsData: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    methods: {
      loadTable () {
        let tableRow = new TableRow();
        tableRow.push(
          new TableColumns()
            ._title('角色名称')
            ._data('roleName')
            ._width('10%')
        );
        tableRow.push(
          new TableColumns()
            ._title('操作人名称')
            ._data('createUserName')
            ._width('10%')
        );
        tableRow.push(
          new TableColumns()
            ._title('验证部门')
            ._data('deptName')
            ._width('10%')
        );
        tableRow.push(
          new TableColumns()
            ._title('操作')
            ._data('operation')
            ._width('10%')
        );
        tableRow.push(
          new TableColumns()
            ._title('操作时间')
            ._data('createTime')
            ._width('10%')
        );
        let column = tableRow._cols();
        this.$nextTick(() => {
          this.$refs.historyRecordTable.setColumn(column, {
            page: false
          });
          this.$refs.historyRecordTable.loadStaticTable(this.tableList);
        });
      }
    },
    mounted () {
      this.tableList = this.detailsData.lcOperationRecordList;
      this.loadTable();
    }
  };
</script>

<style lang="scss" scoped>

</style>
